import { default as CommonTools } from '../utils/common'
import { default as mapApp } from '@/map/init.js'

/**
 * 综合管理
 */
export default class HomeMapActions {

    constructor(map) {
        this.map = map

        this.floor = null;
        this.imageLayer = null;
        this.lineEffectLayer = null;

        this.isInitComplete = false;


        this.homePopVueComponent = null
        this.homePopData = null
        this.homePopMarker = null
    }

    // 外部初始化
    init() {
        if (this.isInitComplete) {
            this.resetView();
            // TODO: 

            return;
        }
        this._init();
        this.isInitComplete = true;
        this.loadActionData()
    }

    // 内部首次初始化层对象至地图
    _init() {
        // 获取层
        this.floor = this.map.getBuildingById(0).getFloor(1);
        // layer name 都填上好对应交互名称(建议唯一)，方便以后全局查找层对象
        //创建普通标注层    
        // this.imageLayer = this.floor.getOrCreateLayerByName('homeImg', esmap.ESLayerType.IMAGE_MARKER)
        //创建特效标注层    
        // this.lineEffectLayer = new esmap.ESEffectTool.EffectLayer('boatsLine', esmap.ESLayer.EFFECT_MARKER);

        // this.floor.addLayer(this.imageLayer);
        // esmap.ESEffectTool.addLayerToMap(this.lineEffectLayer);
    }

    // 重置视角
    resetView() {
        let that = this
        mapApp.mapContainer.clickShadeSign = true
        this.map.cameraFlyTo({
            "directionAngle":227.61,"pitchAngle":80.19,"radius":630.01,"x":13150726.35,"y":4750046.72,"z":0,"time":3,
            callback: function () {
                mapApp.mapContainer.clickShadeSign = false
            }
        })
    }

    // 加载当前交互模块基础配置数据
    loadActionData() {
        let that = this
        esmap.ESJsonFileLoader('./assets/actions/home.json').then((data) => {
            this.homePopData = data.centerMarker
        })
    }
    // 首页气泡
    showHomePopMarker() {
        let that = this
        this.homePopMarker = CommonTools.addPopMarker({
            bid: 0,
            "x":13150611.700450897,"y":4750035.331670281,
            offsetHeight: 1000
        })
        this.homePopMarker.onUpdatePosition(function (transformStyle) {
            that.homePopVueComponent.popTips.transformStyle = transformStyle
            that.homePopVueComponent.popTips.visible = true
        })
    }
    // 气泡关闭
    closeHomePop() {
        if (this.homePopMarker) { this.homePopMarker.close() }
        if (this.homePopVueComponent) this.homePopVueComponent.popTips.visible = false
    }

}